import React, { useState, useEffect } from 'react';
import './Customers.css';
import { getDatabase, onValue, ref } from 'firebase/database';
import Navigation from '../../navigation/Navigation';
import PageHeading from '../../shared/pageHeading/PageHeading';
import AddCustomerButton from './subcomponents/AddCustomerButton';
import ListAll from './subcomponents/ListAll';

const Customers = () => {
	const [customers, setCustomers] = useState([]);
	const [tables, setTables] = useState([]);

	useEffect(() => {
		const db = getDatabase();
		onValue(ref(db, 'tables/'), snapshot => {
			if(snapshot.exists()){
				setTables(
					Object.entries(snapshot.val()).map(([table, uid]) => {
						return { number: Number(table), uid: uid };
					})
				);
			}
		});
		onValue(ref(db, 'users/'), snapshot => {
			if(snapshot.exists()){
				setCustomers(Object.entries(snapshot.val()));
			}
		});
	}, []);
	return (
		<>
			<Navigation />
			<div className='AppContents'>
				<div className='Container'>
					<PageHeading heading={'Kunder'} />
					<AddCustomerButton />
					<ListAll
						data={{
							customers: customers,
							tables: tables
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default Customers;
